module.exports = __webpack_public_path__ + "img/Attendance.ecc9ae43.svg";